module.exports = __webpack_public_path__ + "img/ipad-connected-th.f7bb5a85.svg";